import ReactDOM from "react-dom";
import HealthInsuranceModalV2 from "app/components/modals/HealthInsuranceModalV2";
import { hideModal } from "usecases/commons/hide-modal";
import { showSuccessMessage } from "usecases/commons/show-success-message";
import { showErrorMessage } from "../../commons/show-error-message";
import HexModal from "../../../app/components/modals/HexModal";
import IFeelModal from "../../../app/components/modals/benefits/IFeelModal";
import {
  editBenefit,
  findModels,
} from "../../../infrastructure/repository/benefit-models-repository";
import { findCompanyDetail } from "../../../infrastructure/repository/company-repository";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";
import { showIFeelFeature } from "../../../infrastructure/chosen-company";
import { displayBenefitPage } from "./display-benefit-page";

const updateHealthInsuranceConfig = async (benefit) => {
  try {
    const { data } = await editBenefit(benefit);
    showSuccessMessage(
      translate("benefits-section.benefit-edited-successfully")
    );
    displayBenefitPage(data.id);
  } catch (error) {
    showErrorMessage(
      translate("benefits-section.an-error-occurred-while-editing-the-benefit")
    );
  } finally {
    hideModal();
  }
};

const parseInsuranceConfig = ({ modalities, insuranceConfig }) => {
  const newInsuranceConfig = [];
  modalities.forEach(({ modalityId }) => {
    const config = insuranceConfig.find((ic) => ic.modalityId === modalityId);
    if (config) {
      newInsuranceConfig.push(config);
    }
  });
  return newInsuranceConfig;
};

function renderHealthInsuranceModal({
  insuranceProducts,
  benefitSelected,
  insuranceConfig,
  isIFeel,
  country,
  isLoading,
}) {
  ReactDOM.render(
    <HexModal>
      {isIFeel ? (
        <IFeelModal
          insuranceConfig={insuranceConfig}
          insuranceProducts={insuranceProducts}
        />
      ) : (
        <HealthInsuranceModalV2
          callback={({ payload }) =>
            updateHealthInsuranceConfig({
              ...benefitSelected,
              insuranceConfig: payload,
            })
          }
          data={{
            insuranceConfig,
            insuranceProducts,
          }}
          isLoading={isLoading}
          country={country}
        />
      )}
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayHealthInsuranceModal(benefitId) {
  try {
    renderHealthInsuranceModal({ isLoading: true });
    const { data: company } = await findCompanyDetail();
    const { data: benefitsModels } = await findModels();
    const glovoCompany = showIFeelFeature(company.id);

    const benefitSelected = benefitsModels.find(
      (benefit) => benefit.id === benefitId
    );
    let insuranceConfig = [];

    if (benefitSelected.insuranceConfig.length === 0) {
      insuranceConfig = company.insuranceProducts.map((insurance) => ({
        modalityId: insurance.modalityId,
        allowedFamilyMembers: ["employee"],
        subvention: {
          employee: 0,
          partner: 0,
          descendant: 0,
        },
      }));
    } else {
      // TODO: Compare insuranceProducts with insuranceConfig for render new insurances?
      insuranceConfig = benefitSelected.insuranceConfig;
    }

    renderHealthInsuranceModal({
      insuranceProducts:
        company.insuranceProducts?.filter(({ state }) =>
          ["active", "scheduled"].includes(state)
        ) || [],
      country: company.countryISO2Code,
      benefitSelected,
      insuranceConfig: parseInsuranceConfig({
        modalities: company.insuranceProducts,
        insuranceConfig,
      }),
      isIFeel: glovoCompany,
    });
    addContextLog("info", "renderHealthInsuranceModal", "display-screen", {
      company: company.id,
      benefitSelected,
      insuranceConfig,
    });
  } catch (e) {
    logError(e, `Error to displayHealthInsuranceModal in benefit ${benefitId}`);
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
